<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Marketplace Store Contact Message <small class="text-muted">messages</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="marketplace_store_id" class="col-sm-2 col-form-label">{{ $t('marketplace.marketplace_store') }}</label>
                        <div class="col-sm-4">
                          <select class="form-control" v-on:change="changePlatform(contactMessage.marketplace_store_id)" v-model="contactMessage.marketplace_store_id">
                            <option value="">Please select store platform</option>
                            <option v-for="(marketplaceStore, index) in marketplaceStores" :value="marketplaceStore.id" :key="index">{{ marketplaceStore.store_name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="marketplace_courier_id" class="col-sm-2 col-form-label">{{ $t('marketplace.marketplace_courier') }}</label>
                        <div class="col-sm-3">
                          <select class="form-control" v-model.trim="contactMessage.marketplace_courier_id">
                            <option value="">-- {{ $t('general.input.please_select_courier') }} --</option>
                            <option value="0">All Couriers</option>
                            <option v-for="(marketplaceCourier, index) in marketplaceCouriers" :value="marketplaceCourier.id" :key="index">{{ marketplaceCourier.courier_name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="message_type" class="col-sm-2 col-form-label">{{ $t('marketplace.contact.message_type') }}</label>
                        <div class="col-sm-3">
                          <select class="form-control" v-model.trim="contactMessage.message_type">
                            <option value="upload_tracking">Upload Tracking</option>
                            <option value="confirm_order">Confirm Order</option>
                            <option value="bulk_message">Bulk Message</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="remark" class="col-sm-2 col-form-label">{{ $t('marketplace.contact.contact_user_message') }}</label>
                        <div class="col-sm-6">
                          <textarea rows=6 v-model="contactMessage.contact_user_message" name="contact_user_message" class="form-control"></textarea>
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> {{ $t('marketplace.store.update') }}</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'ContactEditMessage',
  components: {
    loadingPanel
  },
  mounted () {
    this.axios.get('/marketplace/contact-message/' + this.$route.params.id).then(response => {
      if (response.data) {
        this.contactMessage = response.data
        this.marketplaceGroupCouriers = response.marketplace_couriers
        var storeNames = response.marketplace_stores.filter(function (marketplaceStore) {
          return marketplaceStore.id === response.data.marketplace_store_id
        }).map(function (obj) {
          return obj.store_name
        })
        this.marketplaceCouriers = response.marketplace_couriers[storeNames[0]]
        this.contactMessage.marketplace_courier_id = response.data.marketplace_courier_id
        this.marketplaceStores = response.marketplace_stores
      }
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      couriers: [],
      marketplaceStores: [],
      marketplaceCouriers: [],
      marketplaceGroupCouriers: [],
      contactMessage: {
        id: '',
        marketplace_store_id: '',
        marketplace_courier_id: '',
        message_type: '',
        contact_user_message: ''
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  methods: {
    changePlatform (id) {
      var storeNames = this.marketplaceStores.filter(function (marketplaceStore) {
        return marketplaceStore.id === id
      }).map(function (obj) {
        return obj.store_name
      })
      this.marketplaceCouriers = this.marketplaceGroupCouriers[storeNames[0]]
      this.contactMessage.marketplace_courier_id = ''
    },
    handleSubmit () {
      if (this.contactMessage.marketplace_store_id) {
        // create store
        this.showLoadingPanel = true
        this.axios.put('/marketplace/contact-message/' + this.contactMessage.id, this.contactMessage).then(response => {
          this.showLoadingPanel = false
          this.showAlert('success', this.$t('marketplace.contact.success_message'))
          this.message = response.data
        }).catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
      }
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  }
}
</script>
